window.VegasCatalog = {
	popup: function (text) {
		$.toast({
			heading: text,
			position: 'top-right',
			icon: 'success',
			stack: false
		});
	}
};

require('./cart');
require('./images');
require('./input-counter');